import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 12,
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 6,
    marginLeft: 12,
  },
  tableList: {
    marginTop: 12,
    marginBottom: 6,
  },
}));

export default useStyles;
